<script setup lang="ts">
import { Publisher, Subscriber } from 'openvidu-browser'
import { computed } from 'vue'
import OvVideo from '@/components/OvVideo.vue'

const props = defineProps<{
  streamManager?: Publisher | Subscriber | undefined
  connection?: any
}>()

const currentLang = computed(() => {
  const code = (localStorage.getItem('user-locale') || document.documentElement.lang || navigator.language || 'ro')
    .toLowerCase()
    .split('-')[0]
  return code === 'ro' ? 'ro' : 'en'
})

const isScreenShare = computed(() => {
  return props.streamManager?.stream?.typeOfVideo === 'SCREEN'
})

const userName = computed(() => {
  if (props.streamManager && props.streamManager.stream) {
    const { connection } = props.streamManager.stream
    return parseName(connection.data)
  }
  if (props.connection) {
    return parseName(props.connection.data)
  }
  return ''
})

function parseName(data: string | undefined): string {
  if (!data) return ''
  try {
    const parsedJson = JSON.parse(data)
    return parsedJson.userName || ''
  } catch {
    return data
  }
}

const initials = computed(() => {
  const name = userName.value
  if (!name) return '?'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return ((parts[0]![0] ?? '') + (parts[1]![0] ?? '')).toUpperCase()
  }
  return (parts[0]?.[0] ?? '?').toUpperCase()
})

const badgeText = computed(() => {
  return currentLang.value === 'ro' ? 'Ecran' : 'Screen'
})
</script>

<template>
  <div class="video-container" :class="{ 'is-screen-share': isScreenShare }">
    <ov-video v-if="streamManager" :key="streamManager.stream?.streamId" :stream-manager="streamManager" />
    <div v-else class="video-placeholder">
      <div class="placeholder-avatar">{{ initials }}</div>
    </div>
    <div class="video-info">
      <span class="video-info-name" :title="userName">{{ userName }}</span>
      <span v-if="isScreenShare" class="screen-share-badge">
        <svg class="screen-share-badge-icon" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
        <span class="screen-share-badge-text">{{ badgeText }}</span>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
